export default __webpack_public_path__ + "static/media/BBBLogo.ca491780.png";